import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { PlatformGlobalService } from '../../service/platform-global.service';
import { DashboardService } from 'src/app/pages/dashboard/service/dashboard.service';
import { SidenavService } from '../../sidenav/sidenav.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';
import { HostListener } from '@angular/core';

@Component({
  selector: 'prep-toolbar-resources',
  templateUrl: './toolbar-resources.component.html',
  styleUrls: ['./toolbar-resources.component.scss'],
})
export class ToolbarResourcesComponent implements OnInit {
  isOpen: boolean;
  videourl: string;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  isSubmenuOpen = false;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // console.log('open status', this.isOpen);

    if (event.key === 'Escape' && this.isOpen) {
      console.log('Escape key pressed resources');
      // Close the dropdown menu and focus the button

      const button = document.getElementById('resource-menu-button');
      if (button) {
        button.focus();
      }

      this.closeDropdown();
    }
  }

  ngOnInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  profile() {
    console.log('welcome to profile');
    this.router.navigate(['/profile']);
  }

  // Called on Escape key press
  closeDropdown() {
    this.isOpen = false;
  }

  closeDropdownEsc() {
    this.isOpen = false;
    // Ensure the button is focusable and get the focus on it
    const button = document.getElementById('resource-menu-button');
    if (button) {
      button.focus();
    }
  }

  // Called when focus leaves the dropdown menu
  onFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    const menu = document.getElementById('user-menu');

    // If focus moved outside the dropdown, close it
    if (menu && relatedTarget && !menu.contains(relatedTarget)) {
      this.isOpen = false;
    }
  }

  clickGoToResources() {
    this.router.navigate(['/resources']);
  }

  clickGoTpQuickStartGuide() {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = 'assets/document/PREP-Quick-Start-Guide.pdf';
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  clickGoToTraning() {
    console.log(
      'item values',
      this.platformGlobalService.getStoreDashboardInfo
    );
    const urlToken = this.platformGlobalService.getStoreDashboardInfo.url_token;
    if (urlToken !== '') {
      this.videourl = urlToken;
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', this.videourl);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      this.snackbar.open(
        'Training video not Available for this user',
        'OK THANKS',
        {
          duration: 10000,
        }
      );
    }
  }

  toggleSubmenu(): void {
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

  clickSubmenuItem(item: string): void {
    console.log(`Submenu item clicked: ${item}`);
    // Add your logic here for handling submenu item clicks
    switch (item) {
      case 'item1': {
        let youtubelink1 =
          'https://www.youtube.com/watch?v=RbQex1v4plM&list=PLTAD7sYmpKxsONR3nzRru6-CUnbFVwk8N';
        window.open(youtubelink1, '_blank');
        break;
      }
      case 'item2': {
        let youtubelink2 =
          'https://www.youtube.com/watch?v=JKkqUARwNCw&list=PLTAD7sYmpKxv7zFrBDj1BopqQAYDEbMp0';
        window.open(youtubelink2, '_blank');
        break;
      }
      case 'item3': {
        let youtubelink3 =
          'https://www.youtube.com/watch?v=Ie-BMRh8lAY&list=PLTAD7sYmpKxuuNV8xdUfrd8Jp2I0es2BG';
        window.open(youtubelink3, '_blank');
        break;
      }
      case 'item4': {
        let youtubelink4 =
          'https://www.youtube.com/watch?v=scWa7L32GzI&list=PLTAD7sYmpKxsMmZX1YGHnXpwWcuvNLB7r';
        window.open(youtubelink4, '_blank');
        break;
      }
      case 'item5': {
        let youtubelink5 =
          'https://www.youtube.com/watch?v=d0YgdBi5T5U&list=PLTAD7sYmpKxvK6t2GqsdtY7JQqED-7Q3W';
        window.open(youtubelink5, '_blank');
        break;
      }
    }
  }
}
